import { render, staticRenderFns } from "./SVGEditorMessages.vue?vue&type=template&id=c02aeb4c&scoped=true"
import script from "./SVGEditorMessages.vue?vue&type=script&lang=js"
export * from "./SVGEditorMessages.vue?vue&type=script&lang=js"
import style0 from "./SVGEditorMessages.vue?vue&type=style&index=0&id=c02aeb4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02aeb4c",
  null
  
)

export default component.exports